import React from 'react';
import styled from 'styled-components';
import AdminBlockWithVisible from '../../share/component/AdminBlockWithVisible';
import { useAdminExhibitionStore } from '../../share/store/adminExhibitionStore';

const ExhibitionColumnInfo: React.FC = () => {
  const hasViewer = useAdminExhibitionStore((state) => (
    !!state.activeExhibition
    || state.multiSelectedExhibitionIds.length > 1
    || state.isBulkPreviewOpen
    || !!state.bulkResult
  ));

  return (
    <ColumnInfoComp>
      <InfoContainer>
        <TitleBlock>Title</TitleBlock>
        <AdminBlockWithVisible width="1.4" isColumn={true} value="Venue" />
        <AdminBlockWithVisible width="2" isColumn={true} value="Period" />
        <AdminBlockWithVisible width="2" isColumn={true} value="Artists" />
        {hasViewer && <SpaceBlock />}
      </InfoContainer>
      {hasViewer && <OverviewBlock>Overview</OverviewBlock>}
    </ColumnInfoComp>
  );
};

const ColumnInfoComp = styled.article`
  width: 100%;
  height: 38px;
  display: flex;
  border-bottom: 1px solid ${({ theme }) => theme.colors.color_Gray_02};
  user-select: none;
  ${({ theme }) => theme.typography.Body_03_2};
`;

const InfoContainer = styled.article`
  flex: 1;
  width: auto;
  height: 34px;
  display: flex;
`;

const TitleBlock = styled.div`
  flex: 2.4;
  display: flex;
  align-items: center;
  padding-left: 4px;
`;

const SpaceBlock = styled.div`
  flex: 0.15;
`;

const OverviewBlock = styled.div`
  flex: 0 0 29vw;
  width: 29vw;
  min-width: 29vw;
  display: flex;
  align-items: center;
`;

export default ExhibitionColumnInfo;
